<tam-dialog tid="contact_dialog" (mousedown)="onClickSetEventValue($event)" (click)="onClickSetEventValue($event)"
    class="contact-template threaddetail-sidesheet-status" [titleName]="titleName" [opened]="opened"
    [dialogWidth]="dialogWidth" (keydown.esc)="onEnter($event)" (keyup)="keySend($event)"
    (containerEvent)="onContainerEvent($event)" #dialogRef>
    <ng-template #title>
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon *ngIf="false" class="dialog-min dark" name="substract" (click)="windowMinimize()"></smart-icon>
        <smart-icon *ngIf="!isOfficeAddinMode" class="dialog-close dark" name="close"
            (click)="onCancelBtnClick($event)"></smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="body-container">
            <tam-contact-navigation-bar *ngIf='allTemplate' [config]="allTemplate"></tam-contact-navigation-bar>
            <div class="control-container">
                <div class="duplicated-message" *ngIf='isDuplicatedContactName||isDuplicatedContactEmail||hasDuplicateContact'>
                    <smart-icon name='exclamation-circle' class="alert-title-icon" [style.color]="iconColor">
                    </smart-icon>
                    The record you're about to create looks like a duplicate. <span class="view-dupliated"
                        (click)="viewDuplicated()">View Duplicates</span>
                </div>
                <div class="template-container"
                    [ngStyle]="{'height':isDuplicatedContactName||isDuplicatedContactEmail === false ? '100%' : 'calc(100% - 36px)'}">
                    <tam-contact-template [config]="tplConfig" [valueChangeSubject]="valueChangeSubject">
                    </tam-contact-template>
                </div>
                <input id="hidden-contact-dialog" [hidden]='true' value={{dialogWidth}} />
                <input id="hidden-contact-dialog-open-status" [hidden]='true' value={{isDialogClosedForPlugin}} />
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">
            <div class="left-sync">
                <label class="checkbox" *ngIf="isCreateContact&&isOpenedExchangeSync" tam-checkbox
                    [(ngModel)]="isCheckSynch">Synch contact
                    into Exchange</label>
            </div>
            <div>
                <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                    (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">Cancel</button>
                <button tam-button tamType="primary" tamSize="normal" [tamLoading]="isProgressing"
                    [disabled]="isProgressing" class="dialog-button dialog-publish" (click)="publish()">Save</button>
            </div>
        </div>
    </ng-template>
</tam-dialog>